import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { setAuthorization } from '../helpers/api_helper';
import { useDispatch } from 'react-redux';

import { useProfile } from '../Components/Hooks/UserHooks';
import { logoutUser } from '../slices/auth/login/thunk';

const AuthProtected = (props: any) => {
  const dispatch: any = useDispatch();
  const { token } = useProfile();

  useEffect(() => {
    if (token) {
      setAuthorization(token);
    }
  }, [token]);

  // If we're not loading and there's no token, redirect to login
  if (!token) {
    dispatch(logoutUser());
    return <Navigate to="/login" replace />;
  }

  return <>{props.children}</>;
};

export default AuthProtected;
